<template>
    <div class="animated fadeIn">
      <b-form @submit.stop.prevent="onSubmit">
      </b-form>
    </div>
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
    import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
    //import { table } from 'console'
    
    const toastTypes = {
      success: 'success',
      error: 'error',
      info: 'info',
      warn: 'warn'
    }
    
    miniToastr.init({types: toastTypes})
    
    function toast ({title, message, type, timeout, cb}) {
      return miniToastr[type](message, title, timeout, cb)
    }
    
    const options = {
      success: toast,
      error: toast,
      info: toast,
      warn: toast
    }
    VueNotifications.setPluginOptions(options)
    
    Vue.use(VueNotifications, options)
    /* Toast - End */
  
    export default {
      name: 'TransactionManualInsertComponent',
      props: {
         item: {}
      },
      computed: {
          selectedItem() {
              return this.item
          }
      },
      components: {
      },
      data: () => {
          return {
          }
      },
      methods: {
      }
    }
  
  </script>